import axios from 'axios'
import { isAuthenticated, user } from '@/auth.js'

let client = axios.create({ baseURL: process.env.VUE_APP_API_URL })

// add bearer token to all requests
client.interceptors.request.use(config => {
  if (isAuthenticated()) {
    config.headers.Authorization = `Bearer ${user().access_token}`
  }

  return config
})

// automatically return the data of the response
client.interceptors.response.use(response => response.data)

export default client
